import Hero from "components/Hero";
import axios from "axios";
import { useEffect, useState } from "react";
import Select from "react-select";
import Masonry from "react-masonry-css";
import PunkCard from "components/PunkCard";
import { ethers } from "ethers";
import { Button } from "components/Styled";
const Marketplace = () => {
  const [punks, setPunks] = useState([]);
  const [traits, setTraits] = useState([]);
  const [floor, setFloor] = useState(null);
  const [filter, setFilter] = useState({
    page: 0,
    sort: {
      type: "listingTime",
      value: 1,
    },
  });
  const [refetch, setRefetch] = useState(null);
  const [pagesTotal, setPagesTotal] = useState(0);
  const [pages, setPages] = useState([]);
  useEffect(() => {
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/marketplace`, {
        filter,
      })
      .then((result) => result.data)
      .then((data) => {
        setPagesTotal(data.pagesTotal);
        setFloor(ethers.BigNumber.from(data.floor));
        setPunks(
          data.list.map((punk) => {
            punk.info.price = ethers.BigNumber.from(punk.info.price);
            punk.info.listingTime = ethers.BigNumber.from(
              punk.info.listingTime
            );
            return punk;
          })
        );
      });
    // eslint-disable-next-line
  }, [refetch]);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/traits`)
      .then((result) => result.data)
      .then((data) => {
        setTraits(data);
      });
  }, []);
  useEffect(() => {
    setInterval(() => {
      setRefetch(new Date().getTime());
    }, 15000);
  }, []);

  const filterNFTS = (filterName, value) => {
    const f = filter;
    f[filterName] = value;
    setFilter(f);
    setRefetch(new Date().getTime());
  };

  useEffect(() => {
    let arr = [];
    for (let i = 0; i < pagesTotal; i++) {
      arr.push({ page: i, active: filter.page === i });
    }
    setPages(arr);
    // eslint-disable-next-line
  }, [pagesTotal]);

  return (
    <div className="bg-primary text-white font-main tracking-wider">
      <Hero>
        <h1 className="text-6xl text-center w-full mt-20">Marketplace</h1>
        {floor && (
          <Button className="mx-auto mt-2">
            Floor: {ethers.utils.formatEther(floor.toString()).toString()} ETH
          </Button>
        )}

        <form className="mt-10 mb-12 flex w-full">
          <label className="mx-2 w-full max-w-60">
            <span className="mb-2 block">Sort by:</span>
            <Select
              onChange={({ value }) => filterNFTS("sort", value)}
              name="order"
              className="text-black backgrounx-transparent"
              options={[
                {
                  label: "Lower price",
                  value: { sortType: "price", value: -1 },
                },
                {
                  label: "Highter price",
                  value: { sortType: "price", value: 1 },
                },
                {
                  label: "Lower rank",
                  value: { sortType: "rank", value: -1 },
                },
                {
                  label: "Highter rank",
                  value: { sortType: "rank", value: 1 },
                },
                {
                  label: "Newly listed",
                  value: { sortType: "listingTime", value: 1 },
                },
                {
                  label: "Oldest listed",
                  value: { sortType: "listingTime", value: -1 },
                },
              ]}
            />
          </label>
          <label className="mx-2 w-full max-w-60">
            <span className="mb-2 block">Rarity:</span>
            <Select
              onChange={({ value }) => filterNFTS("rarity", value)}
              name="rarity"
              className="text-black backgrounx-transparent"
              options={[
                { value: null, label: "None" },
                ...[1, 2, 3, 4, 5].map((rarity) => {
                  let label = "";
                  for (let i = 0; i < rarity; i++) {
                    label += "💎";
                  }

                  return {
                    label,
                    value: rarity,
                  };
                }),
              ]}
            />
          </label>
          <label className="mx-2 w-full max-w-60">
            <span className="block mb-2">Traits:</span>
            <Select
              onChange={(values) =>
                filterNFTS(
                  "traits",
                  values.map(({ value }) => value)
                )
              }
              isMulti
              name=""
              className="text-black background-transparent"
              options={traits.map((trait) => {
                return {
                  label: trait,
                  value: trait,
                };
              })}
            />
          </label>
        </form>
        <div className="w-full">
          <Masonry
            breakpointCols={{
              default: 3,
              1000: 2,
              500: 1,
            }}
            className="my-masonry-grid w-full"
            columnClassName="my-masonry-grid_column"
          >
            {punks.map((punk) => {
              punk.rarity = punk.rank;

              return (
                <div className=" p-2">
                  <PunkCard
                    listPage={true}
                    className="opacity-100-important"
                    punk={punk}
                  />
                </div>
              );
            })}
          </Masonry>
          <ul className="flex mt-10 justify-center">
            {pages.map(({ page, active }) => {
              return (
                <li
                  className="rounded-full p-4 relative mx-4 cursor-pointer"
                  style={{
                    background: active ? "transparent" : "rgb(127, 235, 122)",
                    border: "1px solid rgb(127, 235, 122)",
                  }}
                  onClick={() => {
                    filterNFTS("page", page);
                    setPages(
                      pages.map((p) => {
                        return {
                          page: p.page,
                          active: p.page === page,
                        };
                      })
                    );
                  }}
                >
                  <span className="centerXY absolute text-XL">{page + 1}</span>
                </li>
              );
            })}
          </ul>
        </div>
      </Hero>
    </div>
  );
};
export default Marketplace;
